import type { ExplorerEntityType } from "../../declarations/IExplorerTypes";
import type { SvgIconComponent } from "@mui/icons-material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonIcon from "@mui/icons-material/Person";
import TagIcon from "@mui/icons-material/Tag";
import CategoryIcon from "@mui/icons-material/Category";
import InventoryIcon from "@mui/icons-material/Inventory";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BuildIcon from "@mui/icons-material/Build";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import MapIcon from "@mui/icons-material/Map";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PaymentsIcon from "@mui/icons-material/Payments";

const nodeColorMap: Record<ExplorerEntityType, string> = {
    SalesOrderHeader: "#1976d2",
    SalesOrderHeaderCharge: "#1976d2",
    SalesOrderLines: "#1976d2",
    SalesOrderLineDetail: "#1976d2",
    CustomerPayments: "#00897b",
    Customer: "#2e7d32",
    VatNum: "#6a1b9a",
    Product: "#e65100",
    ReleasedProduct: "#e65100",
    Vendor: "#5d4037",
    Route: "#7b1fa2",
    RouteOperationDetail: "#7b1fa2",
    BomLines: "#00695c",
    FMRoute: "#00838f",
};

const nodeIconMap: Record<ExplorerEntityType, SvgIconComponent> = {
    SalesOrderHeader: ReceiptLongIcon,
    SalesOrderHeaderCharge: MonetizationOnIcon,
    SalesOrderLines: ListAltIcon,
    SalesOrderLineDetail: AssignmentIcon,
    CustomerPayments: PaymentsIcon,
    Customer: PersonIcon,
    VatNum: TagIcon,
    Product: CategoryIcon,
    ReleasedProduct: InventoryIcon,
    Vendor: StorefrontIcon,
    Route: AccountTreeIcon,
    RouteOperationDetail: BuildIcon,
    BomLines: PrecisionManufacturingIcon,
    FMRoute: MapIcon,
};

export function getNodeColor(entityType: ExplorerEntityType): string {
    return nodeColorMap[entityType] ?? "#1976d2";
}

export function getNodeIcon(entityType: ExplorerEntityType): SvgIconComponent {
    return nodeIconMap[entityType] ?? ReceiptLongIcon;
}
